

import axiosInstance from '@/lib/axios';

export async function getPublicWebRate() {

    const response = await axiosInstance.get('/users/website/public');


    return response.data;

}


